import { render } from "./ExpenseCategory.vue?vue&type=template&id=35c71d07&scoped=true&ts=true"
import script from "./ExpenseCategory.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategory.vue?vue&type=script&lang=ts"

import "./ExpenseCategory.vue?vue&type=style&index=0&id=35c71d07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c71d07"]])

export default __exports__